import { useTranslation } from "react-i18next";
import {QUESTION_TYPES} from "../utils/constants";
import {questionCodeToSVG} from "../utils/questionUtils";
import classes from "./Dropdown.module.css";
import {ReactComponent as DOWN} from "../pages/CreateQuizPage/images/CaretDown.svg"
import YuJaSelect from "./standardization/YuJaSelect";

export default function DropdownQuestionType({questionType, setShownQuestionType, handleQuestionTypeUpdate, dropdownStyle={}}) {
    const { t } = useTranslation();

    const options = Object.values(QUESTION_TYPES).map(type => ({label: t(type.labelKey), value: type.name}));


    const getOptionIcon = (option) => {
        return <span className={classes.icon} style={{width: 24, height: 24}}>{questionCodeToSVG(option.value, true, 16)}</span>;
    }

    const onHover = (option) => {
        setShownQuestionType(option.value);
    }


    return (
        <div style={{position: 'relative', width: 210}}>
            <YuJaSelect
                options={options}
                value={questionType}
                style={{width: 210, padding: "0 10px", ...dropdownStyle}}
                onChange={val => {
                    let option = options.find(opt => opt.value === val);
                    if (!!option) {
                        // pass the stable English identifier; the label is translated
                        handleQuestionTypeUpdate(QUESTION_TYPES[option.value].description);
                    }
                }}
                popupStyle={{maxHeight: 300}}
                itemStyle={{gap: 7, padding: "0 10px"}}
                onOptionHover={onHover}
                downIcon={DOWN}
                getOptionIcon={getOptionIcon}
                onClose={() => setShownQuestionType(questionType)}
            />
        </div>
    );
}